import { LocalPaymentMethod as LocalBancontact, LocalPaymentMethod as LocalP24, LocalPaymentMethod as LocalBLIK, LocalPaymentMethod as LocalEPS, LocalPaymentMethod as LocalGiropay, LocalPaymentMethod as LocalGrabpay, LocalPaymentMethod as LocalIdeal, LocalPaymentMethod as LocalMyBank, LocalPaymentMethod as LocalSofort, } from "./LocalPaymentMethod";
export var Bancontact = LocalBancontact;
export var P24 = LocalP24;
export var Sofort = LocalSofort;
export var BLIK = LocalBLIK;
export var EPS = LocalEPS;
export var Giropay = LocalGiropay;
export var Grabpay = LocalGrabpay;
export var IDeal = LocalIdeal;
export var MyBank = LocalMyBank;
